import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'

import { colors } from 'Constants'

import { getReport } from '../helpers'
import request from 'Request'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import MessageOfficeReport from './components/MessageOfficeReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default () => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reportSets, setReportSets] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    const categories = await request('/info/message-categories/list')
    const newReportSet = await request('/info/app-codes/list').then(res =>
      res.data.map(appCode => ({ appCode, reports: [] }))
    )
    const requests = []
    for (const reportSet of newReportSet) {
      requests.push(
        getReport('/reports/messages/get', {
          appCode: reportSet.appCode,
          startDate,
          endDate,
          showArchivedOffices,
          includeAggregation: true
        }).then(reports => (reportSet.reports = reports))
      )
    }
    await Promise.all(requests)
    setReportSets(newReportSet)
    if (categories.data) setCategories(categories.data)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`Cluster Message Report`}
        csvUrl="/reports/messages/csv"
        csvPayload={reportSortingState}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reportSets.map(reportSet => (
        <>
          <ReportHeader
            header="App Code"
            title={reportSet.appCode}
            cardValues={[]}
          ></ReportHeader>
          {reportSet.reports.map(report => (
            <MessageOfficeReport report={report} categories={categories} />
          ))}
        </>
      ))}
    </>
  )
}
